const isUrlValid = (url) => {
    const regex = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/;
    return regex.test(url);
};

export default isUrlValid;